import './mobxConfig';
import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { Provider } from 'react-redux';
import store from './redux/store';
import { RouterProvider } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { router } from 'Routes';
import ChatWidgetProvider from 'providers/ChatWidgetProvider';
import OAuth2Provider from './OAuthProvider'; // The new OAuth Provider
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toastify.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import { DialogMount } from 'dialogs';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <div id="toast-root">
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
      <DialogMount />
      <I18nextProvider i18n={i18n}>
        <AppProvider>
          <OAuth2Provider>
            <SettingsPanelProvider>
              <ChatWidgetProvider>
                <BreakpointsProvider>
                  <RouterProvider router={router} future={{ v7_startTransition: true }} />
                </BreakpointsProvider>
              </ChatWidgetProvider>
            </SettingsPanelProvider>
          </OAuth2Provider>
        </AppProvider>
      </I18nextProvider>
    </React.StrictMode>
  </Provider>
);
